import {
  BarChart3,
  CalendarClock,
  ClipboardList,
  type LucideIcon,
  NotebookPen,
  Settings,
  ShoppingBasket,
  Sprout,
  Truck,
  Users,
} from 'lucide-react';
import type { PermKey, Perms } from '@farmos/shared';
import type { QuickIntent } from '@/lib/quick';

export interface NavItem {
  to: string;
  perm: PermKey;
  label: `nav.${PermKey}`;
  icon: LucideIcon;
}

/** Managers get the Today tab on the dashboard; workers and sales staff keep landing on their own screen. */
export const canSeeToday = (p: Perms) => p.dash && (p.admin || p.tasks || p.shifts || p.mgmt);

/** Order = priority on the phone bottom bar. */
export const NAV: NavItem[] = [
  { to: '/dashboard', perm: 'dash', label: 'nav.dash', icon: BarChart3 },
  { to: '/harvest', perm: 'harvest', label: 'nav.harvest', icon: Sprout },
  { to: '/sales', perm: 'sales', label: 'nav.sales', icon: ShoppingBasket },
  { to: '/purchases', perm: 'purch', label: 'nav.purch', icon: Truck },
  { to: '/tasks', perm: 'tasks', label: 'nav.tasks', icon: ClipboardList },
  { to: '/shifts', perm: 'shifts', label: 'nav.shifts', icon: CalendarClock },
  { to: '/mgmt', perm: 'mgmt', label: 'nav.mgmt', icon: NotebookPen },
  { to: '/settings', perm: 'settings', label: 'nav.settings', icon: Settings },
];

export interface QuickItem {
  to: string;
  perm: PermKey;
  label: `quick.${string}`;
  icon: LucideIcon;
  /** tailwind classes for the icon tile */
  tone: string;
  intent?: QuickIntent;
}

/** The daily records the + button creates. */
export const QUICK: QuickItem[] = [
  {
    to: '/harvest',
    perm: 'harvest',
    label: 'quick.harvest',
    icon: Sprout,
    tone: 'bg-leaf/12 text-leaf',
  },
  {
    to: '/sales',
    perm: 'sales',
    label: 'quick.sales',
    icon: ShoppingBasket,
    tone: 'bg-sold/12 text-sold',
  },
  { to: '/purchases', perm: 'purch', label: 'quick.purch', icon: Truck, tone: 'bg-ng/12 text-ng' },
  {
    to: '/tasks',
    perm: 'tasks',
    label: 'quick.task',
    icon: ClipboardList,
    tone: 'bg-brand-soft text-brand-2',
    intent: 'task',
  },
  {
    to: '/mgmt',
    perm: 'mgmt',
    label: 'quick.report',
    icon: NotebookPen,
    tone: 'bg-gold/12 text-gold',
    intent: 'report',
  },
  {
    to: '/mgmt',
    perm: 'mgmt',
    label: 'quick.meeting',
    icon: Users,
    tone: 'bg-gap/10 text-gap',
    intent: 'meeting',
  },
];
